// extracted by mini-css-extract-plugin
module.exports = {"buttonDesktop":"AdmButton_buttonDesktop__2sxG7","buttonMobile":"AdmButton_buttonMobile__1Ghhl"};